import { render, staticRenderFns } from "./BlocoArquivo.vue?vue&type=template&id=3be92384"
import script from "./BlocoArquivo.vue?vue&type=script&lang=js"
export * from "./BlocoArquivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports